export default __webpack_public_path__ + "static/media/megaphone 1.5de9554e.svg";